import { render, staticRenderFns } from "./WasteBinsBrowser.yaml?vue&type=template&id=697cb992&component"
import script from "./WasteBinsBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./WasteBinsBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports